export default "__VITE_ASSET__C3UujJL9__"